import { ApiService } from "./api.service";
export default class DirectionService extends ApiService {
  namespace = "direction";
  icon = "Map";
  name = "Type";
  favicon = "Map";
  Width = 790;
  DOMAIN = -5;
  action = "actionMap";
  constructor() {
    super("directions");
  }
}
